'use strict';

export default {
  // initial modal, no messenger connection
  connect: 'connect',
  // messenger connection got invalidated, reconnect
  reconnect: 'reconnect',
};



// WEBPACK FOOTER //
// ./app/src/constants/messenger_modal_types.js